module.exports = __webpack_public_path__ + "static/img/1.52742ea8.png";